<template>
  <div>
    <div class="b-banner-con">
      <v-header></v-header>
      <v-nav></v-nav>
    </div>
    <v-breadcrumb></v-breadcrumb>
    <!-- 主题内容 -->
    <div class="b-center-container">
      <!-- 富文本 -->
      <div class="b-container">
        <div class="b-center-main">
          <div class="b-richtext">
            <p v-html="richText"></p>
          </div>
        </div>
      </div>
    </div>
    <v-contact></v-contact>
    <!--
    <v-footer></v-footer>
    <v-copy></v-copy>
    -->
  </div>
</template>
<script>
/* eslint-disable */
import Header from "@/components/header/";
import Nav from "@/components/nav/";
import Copy from "@/components/copy/"
import Breadcrumb from "@/components/breadcrumb/"
import Footer from "@/components/footer/"
import Contact from "@/components/contact/";
import $ from "jquery";
export default {
  data () {
    return {
      richText: '',
    };
  },
  mounted () {
    var id = this.$route.query.id;
    var type = this.$route.query.type;
    var noticeType = this.$route.query.noticeType;
    var category = this.$route.query.category;
    var baseUrl =  Header.IP_URL + '/';
    if(type=='news')
      baseUrl = baseUrl + 'news/detail?newsId='+id;
    else if(type=='topics')
      baseUrl = baseUrl + 'topics/detail?topicsId='+id;
    else if(type=='activitys')
      baseUrl = baseUrl + 'activitys/detail?activitysId='+id;
    else if(type=='notice' && noticeType=='home_notice')
      baseUrl = baseUrl + 'notice/detail?noticeId='+id + '&noticeType=home_notice';
    else if(type=='notice' && noticeType=='recruit_notice')
      baseUrl = baseUrl + 'notice/detail?noticeId='+id + '&noticeType=recruit_notice';
    else if(type=='achievements')
      baseUrl = baseUrl + 'achievements/detail?achievementsId='+id;
    else if(type=='cooperations')
      baseUrl = baseUrl + 'cooperations/detail?cooperationsId='+id;
    else if(type=='sciences')
      if (category == 'kpjt')
        baseUrl = baseUrl + 'sciences/detail?category=kpjt&sciencesId='+id;
      else
        baseUrl = baseUrl + 'sciences/detail?sciencesId='+id;
    else if(type=='rules')
      baseUrl = baseUrl + 'rules/detail?rulesId='+id;

    else if(type=='user_stations')
      baseUrl = baseUrl + 'user_stations/detail?userStationsId='+id;

    var self = this;

    $.ajax({
      url: baseUrl,
      type: 'get',
      // data: {},
      dataType: 'json'
    }).then(function (res) {
      //把从json获取的数据赋值给数组
      console.log(res.data.title);

      if(type=='user_stations'){
        //简介
        var description = res.data.description;
        description = description.replace(/<p>/g, "<p style=\"text-indent:2em; margin-bottom : 20px; font-size: 16px;width:1078px;line-height:32px;margin: auto;\">");
        description = description.replace(/<p style=\"text-align: center;\">/g, '<p style="text-align: center;margin-bottom : 20px; font-size: 16px;">');

        description = description.replace(/width:1078px;line-height:32px;margin: auto;"><img/g, 'text-align:center;"><img');

        description = description.replace(/\/ueditor\/images/g, Header.IP_URL + "/ueditor/images");

        //设置图片的宽度
        // 先去除原来的 设置

        description = description.replace(/height="(\d*)"/g, '');
        console.log(description);
        description = description.replace(/width="(\d*)"/g, '');
        console.log(description);

        // 统一设置 800px
        var regex = new RegExp('<img', 'gi');
        description = description.replace(regex, '<img style="width: 650px;"');

        //科研目标
        var target = res.data.target;
        target = target.replace(/<p>/g, "<p style=\"text-indent:2em; margin-bottom : 20px; font-size: 16px;width:1078px;line-height:32px;margin: auto;\">");
        target = target.replace(/<p style=\"text-align: center;\">/g, '<p style="text-align: center;margin-bottom : 20px; font-size: 16px;">');

        target = target.replace(/width:1078px;line-height:32px;margin: auto;"><img/g, 'text-align:center;"><img');

        target = target.replace(/\/ueditor\/images/g, Header.IP_URL + "/ueditor/images");

        //设置图片的宽度
        // 先去除原来的 设置

        target = target.replace(/height="(\d*)"/g, '');
        console.log(target);
        target = target.replace(/width="(\d*)"/g, '');
        console.log(target);

        // 统一设置 800px
        //var regex = new RegExp('<img', 'gi');
        target = target.replace(regex, '<img style="width: 650px;"');

        //科研成果
        var achievements = res.data.achievements;
        achievements = achievements.replace(/<p>/g, "<p style=\"text-indent:2em; margin-bottom : 20px; font-size: 16px;width:1078px;line-height:32px;margin: auto;\">");
        achievements = achievements.replace(/<p style=\"text-align: center;\">/g, '<p style="text-align: center;margin-bottom : 20px; font-size: 16px;">');

        achievements = achievements.replace(/width:1078px;line-height:32px;margin: auto;"><img/g, 'text-align:center;"><img');

        achievements = achievements.replace(/\/ueditor\/images/g, Header.IP_URL + "/ueditor/images");

        //设置图片的宽度
        // 先去除原来的 设置

        achievements = achievements.replace(/height="(\d*)"/g, '');
        console.log(achievements);
        achievements = achievements.replace(/width="(\d*)"/g, '');
        console.log(achievements);

        // 统一设置 800px
        //var regex = new RegExp('<img', 'gi');
        achievements = achievements.replace(regex, '<img style="width: 650px;"');

        //科研成果 附图
        var achievementPics = res.data.achievementPics;
        achievementPics = achievementPics.replace(/<p>/g, "<p style=\"text-indent:2em; margin-bottom : 20px; font-size: 16px;width:1078px;line-height:32px;margin: auto;\">");
        achievementPics = achievementPics.replace(/<p style=\"text-align: center;\">/g, '<p style="text-align: center;margin-bottom : 20px; font-size: 16px;">');

        achievementPics = achievementPics.replace(/width:1078px;line-height:32px;margin: auto;"><img/g, 'text-align:center;"><img');

        achievementPics = achievementPics.replace(/\/ueditor\/images/g, Header.IP_URL + "/ueditor/images");

        //设置图片的宽度
        // 先去除原来的 设置

        achievementPics = achievementPics.replace(/height="(\d*)"/g, '');
        console.log(achievementPics);
        achievementPics = achievementPics.replace(/width="(\d*)"/g, '');
        console.log(achievementPics);

        // 统一设置 800px
        //var regex = new RegExp('<img', 'gi');
        achievementPics = achievementPics.replace(regex, '<img style="width: 650px;"');

        self.richText =
          '<p style="text-align: left; "><span style="font-size: 22px; border-bottom: solid 3px #033d80;">在站科研用户</span></p>'
          + '<p style="margin-top:50px; margin-bottom: 0px"><span style="font-size: 20px;">【工作站】' + res.data.title + '</span></p>'
          + '<p style="margin-top:10px; margin-bottom: 0px"><span style="font-size: 20px;">【负责人】' + res.data.principal + '</span></p>'
          + '<p style="margin-top:10px; margin-bottom: 0px"><span style="font-size: 20px;">【合作伙伴】' + res.data.partner + '</span></p>'

          + '<p style="margin-top:20px; margin-bottom: 0px"><span style="font-size: 20px;">【工作站简介】</span></p>'
          + description

          + '<p style="margin-top:50px; margin-bottom: 0px"><span style="font-size: 20px;">【科研目标】</span></p>'
          + target

          + '<p style="margin-top:20px; margin-bottom: 0px"><span style="font-size: 20px;">【代表性成果】</span></p>'
          + achievements

          + achievementPics;



      } else if (type=='sciences' && category=='kpjt'){
        self.richText = '<p style="margin-bottom : 40px; "><span style="font-size: 20px; "><strong>' + res.data.title + '</strong></span></p>'
          + '<p style="margin-bottom : 30px; "><span style="font-size: 12px; ">' + res.data.publish_time + '</span></p>'
          + '<hr style="line-height: 1.8; border-bottom: 1px solid #d6d6d6; margin-bottom : 40px">'
          + '<p style="text-indent: 28px; text-align: center;"><video controls="controls" src="' +res.data.url+ '" style="margin:0 auto;max-width: 100%;">您的浏览器不支持 video 标签。</video></p>';
      }
      else {
        var content = res.data.content;
        content = content.replace(/<p>/g, "<p style=\"text-indent:2em; margin-bottom : 20px; font-size: 16px;width:1078px;line-height:32px;margin: auto;\">");
        content = content.replace(/<p style=\"text-align: center;\">/g, '<p style="text-align: center;margin-bottom : 20px; font-size: 16px;">');

        content = content.replace(/width:1078px;line-height:32px;margin: auto;"><img/g, 'text-align:center;"><img');

        content = content.replace(/\/ueditor\/images/g, Header.IP_URL + "/ueditor/images");
        content = content.replace(/\/ueditor\/file/g, Header.IP_URL + "/ueditor/file");
        content = content.replace(/\/ueditor\/video/g, Header.IP_URL + "/ueditor/video");

        //设置图片的宽度
        // 先去除原来的 设置

        content = content.replace(/height="(\d*)"/g, '');
        console.log(content);
        content = content.replace(/width="(\d*)"/g, '');
        console.log(content);

        // 统一设置 800px
        var regex = new RegExp('<img', 'gi');
        content = content.replace(regex, '<img style="width: 650px;"');
        self.richText = '<p style="margin-bottom : 40px; "><span style="font-size: 20px; "><strong>' + res.data.title + '</strong></span></p>'
          + '<p style="margin-bottom : 30px; "><span style="font-size: 12px; ">' + res.data.publish_time + '</span></p>'
          + '<hr style="line-height: 1.8; border-bottom: 1px solid #d6d6d6; margin-bottom : 40px">'
          + content;
      }
    }).fail(function () {
      console.log('失败');
    });
  },
  components: {
    "v-header": Header,
    "v-nav": Nav,
    "v-copy": Copy,
    "v-breadcrumb": Breadcrumb,
    "v-footer": Footer,
    "v-contact": Contact,
  }
};
</script>
<style lang="scss">
  @media screen and (max-width:600px) {
	.b-banner-con{
	    //padding: 22px 0;
	    background: url(../../assets/img/banner_bg.png) no-repeat!important;
	    background-size: cover!important;
	    .b-header{
	      margin-bottom: 0px;
	    }
	    height: 134px;
	    width: 1440px;
	}
  }

  @media screen and (min-width:960px) {
      @media screen and (max-width:600px) {
	.b-banner-con{
	    //padding: 22px 0;
	    background: url(../../assets/img/banner_bg.png) no-repeat!important;
	    background-size: cover!important;
	    .b-header{
	      margin-bottom: 0px;
	    }
	    height: 134px;
	    width: 1440px;
	}
  }

  @media screen and (min-width:960px) {
    .b-banner-con{
	    //padding: 22px 0;
	    background: url(../../assets/img/banner_bg.png) no-repeat!important;
	    background-size: cover!important;
	    .b-header{
	      margin-bottom: 0px;
	    }
	    height: 134px;
    }
  }
  }
  .b-richtext {
    text-align:left;
    b,
    strong {
      font-weight: 700;
    }
    p {
      margin: 0 0 10px;
    }
    line-height: 32px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/detail/index.vue